import React, { useEffect, useRef, useState } from "react";
import "./notificationsPage.css";
import { useDispatch, useSelector } from "react-redux";
import { Stack } from "@mui/system";
import { Pagination, Tooltip } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import FilterListRoundedIcon from "@mui/icons-material/FilterListRounded";
import axios from "axios";
// import FOLDER from "../../src/asstes/Folder2.png";
import FOLDER from "../../asstes/Folder2.png";
import LeftArrow from "../../asstes/LeftArrow.png";
import Loader from "../../components/Loader";
import { FileLoader } from "../../constants/Constants";
import { setbuttonTop } from "../../app/features/counterSlice";
import { useNavigate} from "react-router-dom";
// import LeftArrow from "../../src/asstes/LeftArrow.png";
const NotificationsPage = () => {
  const dispatch = useDispatch();
  const totalNotifications = useSelector(
    (state) => state.user.totalNotifications
  );
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const folderName = useSelector((state) => state.folderName);
  const userInfo = useSelector((state) => state.user.userInfo);
  const token = useSelector((state) => state.user.token);
  const [notiChecklist, setNotiChecklist] = useState([]);
  const notiUpdated = useSelector((state) => state.user.isnotiupdated);
  const [statusFilter, setStatusFilter] = useState("");
  const [showUnread, setShowUnread] = useState(null);
  const showRef = useRef(null);
  const [isShow, setIsShow] = useState(false);
  const [isAll, setIsAll] = useState(false);
  const [notiList, setNotiList] = useState([])
  const FolderGet = useSelector((state) => state.FolderGet.FolderName);
  // //console.log(FolderGet, "FolderGet")
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (showRef.current && !showRef.current.contains(event.target)) {
        setIsShow(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const appendIdentifiers = (identifier) => {
    setIsAll(false);
    setNotiChecklist((prevList) =>
      prevList.includes(identifier)
        ? prevList.filter((id) => id !== identifier)
        : [...prevList, identifier]
    );
  };

  const [pageNumber, setPageNumber] = useState(1);

  const NextPage = (event, value) => {
    setPageNumber(value);
  };
  const pageSize = 8;

  const getDaysAgo = (date) => {
    const diffInMs = new Date() - new Date(date);
    const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
    const days = Math.floor(diffInMinutes / (60 * 24));
    const hours = Math.floor((diffInMinutes % (60 * 24)) / 60);
    const minutes = diffInMinutes % 60;

    if (days > 0) {
      return `${days} day(s), ${hours} hour(s), ${minutes} minute(s) ago`;
    }
    if (hours > 0) {
      return `${hours} hour(s), ${minutes} minute(s) ago`;
    }
    return `${minutes} minute(s) ago`;
  };
  const fetchNotifications = async () => {
    setLoading(true);
    try {
      const body = {
        isRead: false,
        foldername: folderName
        // ...(isRead !== null && { isRead }),
        // ...(searchTerm !== "" && { searchTerm }),
      };
      // const response = await fetch(`${FileLoader}/fileloaderv1/Notifications/GetAllNotifications`, {
      const response = await fetch(`https://f067-39-39-61-57.ngrok-free.app/fileloaderv1/Notifications/GetAllNotifications`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      });

      if (response.ok) {
        const result = await response.json();
        // //console.log(result?.data?.list, "API Response");

        setNotiList(result?.data?.list || []);
      } else {
        // const errorData = await response.json();
        console.error("Error from server:");
        // return rejectWithValue(errorData);
      }
    }
    catch (error) {
      //console.log("API call failed:", error);
    }
    setLoading(false);

  }
  useEffect(() => {
    fetchNotifications()
  }, [])


  // const markAllAsRead = async () => {
  //   try {
  //     const response = await axios.put(
  //       `${API}/Notification/MarkAllNotificationsAsRead`,
  //       undefined,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     if (response.data.statusCode == 200) {
  //       dispatch(
  //         fetchNotifications({
  //           PageNumber: pageNumber,
  //           pageSize: 7,
  //           isRead: showUnread,
  //           searchTerm: statusFilter,
  //         })
  //       );
  //       cogoToast.success("All notifications have been marked as read.", {
  //         position: "top-center",
  //       });
  //     } else {
  //       cogoToast.error("Error processing your request.", {
  //         position: "top-center",
  //       });
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  // const markAsRead = async () => {
  //   try {
  //     if (isAll) {
  //       markAllAsRead();
  //       return;
  //     }
  //     if (notiChecklist.length == 0) {
  //       cogoToast.warn("Please select a notification to mark as read.", {
  //         position: "top-center",
  //       });
  //       return;
  //     }
  //     const response = await axios.put(
  //       `${API}/Notification/MarkNotificationsAsRead`,
  //       notiChecklist,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     if (response.data.statusCode == 200) {
  //       dispatch(
  //         fetchNotifications({
  //           PageNumber: pageNumber,
  //           pageSize: 7,
  //           isRead: showUnread,
  //           searchTerm: statusFilter,
  //         })
  //       );
  //       cogoToast.success("Notifications have been marked as read.", {
  //         position: "top-center",
  //       });
  //     } else {
  //       cogoToast.error("Error processing your request.", {
  //         position: "top-center",
  //       });
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  // useEffect(() => {
  //   dispatch(
  //     fetchNotifications({
  //       PageNumber: pageNumber,
  //       pageSize: 7,
  //       isRead: showUnread,
  //       searchTerm: statusFilter,
  //     })
  //   );
  // }, [pageNumber, showUnread, statusFilter, notiUpdated]);

  // const addUserObject = async (connection, connectionId) => {
  //   if (connection) {
  //     const user = {
  //       ConnectionId: connectionId,
  //       UserType: Number(3),
  //       Identifier: userInfo?.identifier,
  //       Username: userInfo?.firstName + " " + userInfo?.lastName,
  //     };

  //     try {
  //       await connection.invoke("AddUserObject", user);
  //     } catch (error) {}
  //   }
  // };

  // useEffect(() => {
  //   SignalRService.connection.on("ReceiveNotification", (msg) => {
  //     dispatch(
  //       fetchNotifications({
  //         PageNumber: pageNumber,
  //         pageSize,
  //         isRead: showUnread,
  //         searchTerm: statusFilter,
  //       })
  //     );
  //   });
  //   let connection;
  //   const connectToHub = async () => {
  //     try {
  //       const hubConnection = new signalR.HubConnectionBuilder()
  //         .withUrl(`${API}/hubs/notification`, {
  //           accessTokenFactory: () => userInfo.authToken,
  //         })
  //         .withAutomaticReconnect()
  //         .build();
  //       await hubConnection.start();
  //       connection = hubConnection;
  //       connection.on("Connected", (connId) => {
  //         addUserObject(connection, connId);
  //       });
  //       connection.on("ReceiveNotification", (msg) => {
  //         dispatch(
  //           fetchNotifications({
  //             PageNumber: pageNumber,
  //             pageSize,
  //             isRead: showUnread,
  //             searchTerm: statusFilter,
  //           })
  //         );
  //       });
  //       return connection;
  //     } catch (error) {
  //       ////console.log(error);
  //     }
  //   };
  //   connectToHub();
  //   return () => {
  //     if (connection) {
  //       connection.stop();
  //       connection = null;
  //     }
  //   };
  // }, [pageNumber]);

  // const onNotificationClick = (caseIdentifier, message) => {
  //   if (caseIdentifier) {
  //     if (message.includes("FinalizedBySigningRadiologist")) {
  //       dispatch(setAddendumList(false));
  //       dispatch(setFinalizeListTemp(true));
  //     } else if (message.includes("AddendumFinalizedBySigningRadiologist")) {
  //       dispatch(setAddendumList(true));
  //       dispatch(setFinalizeListTemp(false));
  //     } else {
  //       dispatch(setAddendumList(false));
  //       dispatch(setFinalizeListTemp(false));
  //     }
  //     router.push(`/Radiologist/Worklist?identifier=${caseIdentifier}`);
  //   }
  // };

   const goBack = () => {
      
        navigate("/");
        dispatch(setbuttonTop(false));
        // setTab(0);
        // setDisplayIFrame(false);
    
    };
  return (
    <div
      className="w-[96%] notifications-container negativeMargin font-family"
      style={{ padding: "1rem 1rem 0 1rem", margin: '0px 2rem' }}
    >
      <div
        className="flex justify-between items-start"
        style={{ marginBottom: "1rem" }}
      >
        <h2 className="text-2xl font-bold text-gray-800 FontFamilyGilroy">Notifications</h2>
        <div className="flex gap-x-3">
          <div className="flex bg-white border-[1px] border-gray-300 text-black rounded-lg">
          <form autocomplete="off"> 
            <input
              onChange={(e) => setStatusFilter(e.target.value)}
              type="text"
              placeholder="Search Notification..."
              className="bg-white rounded-lg placeholder-slate-400  text-[13px]"
              style={{ padding: "0.35rem", outline: "none" }}
            />
            </form>
            <div ref={showRef} className="relative">
              <button
                onClick={() => setIsShow(!isShow)}
                className="paddingLeftRight paddingYAxis flex items-center gap-x-2 text-xs text-black"
              >
                <span>
                  <FilterListRoundedIcon fontSize="small" />
                </span>
              </button>
              {isShow && (
                <div className="absolute cursor-pointer w-24 border-[1px] bg-white border-gray-300 rounded-lg shadow-lg top-10 z-50 text-black">
                  <div
                    onClick={() => {
                      setIsShow(false);
                      setShowUnread(null);
                    }}
                    className="hover:bg-white rounded-t-lg"
                    style={{ padding: "0.2rem", paddingLeft: "0.5rem" }}
                  >
                    All
                  </div>
                  <div
                    onClick={() => {
                      setIsShow(false);
                      setShowUnread(true);
                    }}
                    className="hover:bg-white "
                    style={{ padding: "0.2rem", paddingLeft: "0.5rem" }}
                  >
                    Read
                  </div>
                  <div
                    onClick={() => {
                      setIsShow(false);
                      setShowUnread(false);
                    }}
                    className="hover:bg-white  rounded-b-lg"
                    style={{ padding: "0.2rem", paddingLeft: "0.5rem" }}
                  >
                    Unread
                  </div>
                </div>
              )}
            </div>
          </div>

          <button
            // onClick={markAsRead}
            className="paddingLeftRight paddingYAxis rounded-lg flex items-center gap-x-2 text-xs border-[1px] border-gray-400 text-black"
          >
            <span>
              <VisibilityOutlinedIcon fontSize="small" />
            </span>
            <span>Mark as Read</span>
          </button>
          {/* <button
            onClick={markAsRead}
            className="paddingLeftRight paddingYAxis shadow-lg rounded-lg flex items-center gap-x-2 text-xs border-[1px] border-gray-400 text-black"
          >
            <span>Mark as Read</span>
          </button> */}
        </div>
      </div>
      {/* <div
        className="flex justify-center space-x-2"
        style={{
          display: "flex",
          justifyContent: "space-evenly",
        }}
      >
       
        <div className="flex w-11/12 text-xs md:test-sm text-purple-800 bg-white border h-12 mt-3 rounded-xl mb-4 shadow-md">
          <div className="inline-flex md:w-full h-full">
            <Tooltip title="Back">
              <div className="flex cursor-pointer mx-3 items-center" onClick={goBack}>
                {" "}
                <img src={LeftArrow} height="20px" width="20px" alt="img" />
              </div>
            </Tooltip>

            <Tooltip title={`${folderName}`}>
              <div className="flex cursor-pointer font-bold items-center">
                {" "}
                <img
                  src={FOLDER}
                  className="mx-2"
                  height="20px"
                  width="20px"
                  alt="img"
                />
                <p
                  className="flex my-auto"
                  onClick={() => {
                    navigate(`/`);
                    // setTab(0);
                  }}
                >
                  {" "}
                 Notifications
                </p>{" "}
                /{" "}
              </div>
            </Tooltip>
          </div>

        </div>
      </div> */}
      {/* Content with flex-grow */}
      <div className="notifications-content">
        {notiList?.length > 0 && (
          <div className="flex gap-x-3" style={{ paddingLeft: "8px" }}>
            <input type="checkbox" onChange={() => setIsAll(!isAll)} />
            <div className="text-black FontFamilyGilroy">Select All</div>
          </div>
        )}
        <div>
          {loading ? (
            <div className="flex justify-center items-center h-20">
              {/* <CircularProgress /> */}
              <Loader />
              {/* <span className="loader border-t-4 border-blue-500 border-solid rounded-full w-8 h-8 animate-spin"></span> */}
            </div>
          ) : notiList.length > 0 ? (
            notiList.map((notification) => (
              <div
                key={notification.identifier}
                className={`flex justify-between items-center marginYAxis cursor-pointer border-[1px] border-gray-300 rounded-lg shadow-md ${notification.isRead ? "opacity-90" : "opacity-100"
                  } hover:bg-gray-50`}
                style={{ padding: "0.3rem" }}
              >
                <div className="flex gap-x-3">
                  <div>
                    <input
                      type="checkbox"
                      checked={notiChecklist.includes(notification.identifier) || isAll}
                      onClick={(e) => e.stopPropagation()}
                      onChange={() => appendIdentifiers(notification.identifier)}
                    />
                  </div>
                  <div>
                    <div
                      className={`FontFamilyGilroy ${!notification.isRead ? "text-[#0644aa]" : "text-gray-700"
                        }`}
                    >{notification.message}</div>
                    <div className="text-xs text-gray-500 FontFamilyGilroy">
                      {`Created ${getDaysAgo(notification.createdOn)}`}
                    </div>
                  </div>
                </div>
                {!notification.isRead && (
                  <span className="text-blue-500 text-xs font-medium FontFamilyGilroy">
                    New Notification!
                  </span>
                )}
              </div>
            ))
          ) : (
            <div className="text-black text-sm">No new notifications.</div>
          )}
        </div>
        {/* {loading ? (
          <div className="flex justify-center items-center h-20">
            <span className="loader border-t-4 border-blue-500 border-solid rounded-full w-8 h-8 animate-spin"></span>
          </div>
        ) :
          notiList?.length > 0 &&
          notiList.map((notification) => (
            <div
              // onClick={() =>
              //   onNotificationClick(
              //     notification.redirectURL,
              //     notification.message
              //   )
              // }
              style={{ padding: "0.3rem" }}
              key={notification.identifier}
              className={`flex justify-between items-center marginYAxis cursor-pointer border-[1px] border-gray-300 rounded-lg shadow-md ${notification.isRead ? "opacity-90" : "opacity-100"
                } hover:bg-gray-50`}
            >
              <div className="flex gap-x-3">
                <div>
                  <input
                    type="checkbox"
                    checked={
                      notiChecklist.includes(notification.identifier) || isAll
                    }
                    onClick={(e) => e.stopPropagation()}
                    onChange={() => appendIdentifiers(notification.identifier)}
                  />
                </div>
                <div>
                  <div className="text-gray-700 FontFamilyGilroy">{notification.message}</div>
                  <div className="text-xs text-gray-500 FontFamilyGilroy">
                    {`Created ${getDaysAgo(notification.createdOn)}`}
                  </div>
                </div>
              </div>
              {!notification.isRead && (
                <span className="text-blue-500 text-xs font-medium FontFamilyGilroy">
                  New Notification!
                </span>
              )}
            </div>
          ))}
        {notiList.length === 0 && (
          <div className="text-black text-sm">No new notifications.</div>
        )} */}
      </div>
      <div
        className="flex w-full justify-center items-center gap-2 text-black"
        style={{ marginTop: "1rem" }}
      >
        <Stack spacing={0.5}>
          <Pagination
            count={Math.ceil(totalNotifications / 8)}
            page={pageNumber}
            onChange={NextPage}
            shape="rounded"
            style={{ color: "#A0AEC0" }}
            siblingCount={0}
            boundaryCount={1}
            className="wl-pagination"
          />
        </Stack>
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default NotificationsPage;
